import React from "react";
import { useContext } from "react";
import { ThemeContext } from "../../../../theme/ThemeContext";
import data from "../../../../contants/texts.json";
import FootBlock from "../../../../components/ui/FootBlock";
import { Link } from "react-router-dom";
import AdressList from "../../../../components/ui/AdressList";

const FooterNavigation = () => {
  const texts = data.footerNav;
  const { ct, bg } = useContext(ThemeContext);

  return (
    <div className={`bg-primary py-[65px]`}>
      <div
        className={`${ct} grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-x-12 gap-y-14`}
      >
        <FootBlock prop={"col-span-1 lg:col-span-2"} Label>
          <p className="text-[13px] text-gray-200">{texts[0].text}</p>
          <a
            href="https://instagram.com/djibservice?igshid=YmMyMTA2M2Y="
            target="_blank"
            rel="noreferrer"
          >
            <button
              className={`${bg} px-[28px] py-[15px] text-white text-[12px]`}
            >
              {texts[0].action}
            </button>
          </a>
        </FootBlock>
        <FootBlock label={texts[1].label}>
          <ul className="space-y-2.5 text-gray-200 text-[14px]">
            {texts[1].links.map((item, index) => {
              if (item.text === "A Propos") {
                return (
                  <li key={index}>
                    <a
                      href="https://share.google/PhGEsdH7MJy40fkve"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {item.text}
                    </a>
                  </li>
                );
              } else {
                return (
                  <li key={index}>
                    <Link to={item.path}>{item.text}</Link>
                  </li>
                );
              }
            })}
          </ul>
        </FootBlock>
        <FootBlock label={texts[2].label} prop={"col-span-1 lg:col-span-2"}>
          <AdressList data={texts[2].addresItem} />
        </FootBlock>
        <FootBlock label={texts[3].label} prop={"col-span-1 lg:col-span-2"}>
          <ul className="space-y-2.5 text-gray-200 text-[14px]">
            {[
              {
                text: "Instagram",
                link: "https://www.instagram.com/debarras_lyon_pro?igsh=cW0yenZiNDh4Mzc4",
              },
              { text: "Youtube", link: "https://www.youtube.com/@DjibService" },
            ].map((el, key) => (
              <li key={key}>
                <a href={el.link} target="_blank" rel="noreferrer">
                  {el.text}
                </a>
              </li>
            ))}
          </ul>
        </FootBlock>
      </div>
    </div>
  );
};

export default FooterNavigation;
